import React from 'react';

import ChatToolbar from './components/ChatToolbar';
import MyChatList from './MyChatList';

class Maximized extends React.Component {

  state = {
    is_writing: false,
  }

  switchState(state) {
    this.setState({
        is_writing: state
    });
  }

  minimize = () => {
    this.props.minimize();
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', height: "100%" }}>
          <ChatToolbar
            is_writing={this.state.is_writing}
            languages={this.props.languages}
            selected_language = {this.props.selected_language}
            updateLanguage={this.props.updateLanguage}
            params={this.props.params}
            minimize={this.minimize}
          />
          <MyChatList
            is_writing={this.switchState.bind(this)}
            selected_language = {this.props.selected_language}
            params={this.props.params}
            minimize={this.minimize}
          />
        </div>
      </div>
    )
  }
}

export default Maximized;
